<template>
  <div class="ExclusiveActivities">
    <div class="onehome">
      <van-icon @click='back' class="return" color="#fff" name="arrow-left" />
      <h3 class="title">活动</h3>
      <div class="imgbox">
        <van-icon name="chat-o" size='.6rem' color='#fff' @click='toModule("/personal/News")' />
        <van-icon name="scan" style="margin-left:6px" color="#fff" size='.6rem' @click='toScan' />
      </div>
    </div>
    <div class="titlef">
        <h3>园区福利</h3>
        <!-- <p>更多福利></p> -->
    </div>
    <van-list v-model="loading" :finished="finished" @load="loadMore">
      <div class="boxBig" v-for="(item, index) in boxinfo" :key="index"  @click="detalis(item.welfareId)">
        <img :src="item.banner" alt="" class="img_b">
        <div class="content in_b">
          <p class="boxTitle textOver">{{ item.title }}</p>
          <!-- <p class="boxPreferential textOver">{{ item.discountLimit }}</p> -->
          <van-notice-bar :text='item.discountLimit'/>
          <p class="boxCompany textOver">福利来自：{{ item.providerName }}</p>
          <p class="boxLimitTime">有效限期：{{ item.beginTime | DateFilter}}至{{item.endTime | DateFilter}}</p>
        </div>
      </div>
    </van-list>
    <div>
      <van-tabbar v-model="active">
        <van-tabbar-item :to="`/index?parkId=${this.currentParkId}`"><div class="divicon"><van-icon size='22px' name="wap-home" />首页</div></van-tabbar-item>
        <van-tabbar-item to="/propertys"><div class="divicon"><van-icon size='22px' name="like-o" />服务</div></van-tabbar-item>
        <van-tabbar-item :to="`${this.currentParkId == 1003||this.currentParkId == 1000||this.currentParkId == 1006?'/parkCompleteSet/foodCourt':'/humanResource/jobList'}`"><div class="divicon"><van-icon size='22px' name="location-o" />附近</div></van-tabbar-item>
        <van-tabbar-item to="/parkCompleteSet/ExclusiveActivities"><div class="divicon"><van-icon size='22px' name="point-gift-o" />活动</div></van-tabbar-item>
        <van-tabbar-item to="/personal"><div class="divicon"><van-icon size='22px' name="contact" />我的</div></van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return{
      active: 3,
      pageIndex: 1,
      boxinfo: [],
      total: 0,
      loading: false,
      finished: false,
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
    }
  },
  methods: {
    detalis(id) {
      this.$router.push({ path: `/ExclusiveDetalis/${id}` });
    },
    getinfo() {
      this.$http.post(`${this.URL_PREFIX}/app/get/welfare/info/list`,{
        currPage: this.pageIndex,
        pageRows: 10,
        parkId: this.currentParkId,
      }).then((res) => {
        if(res.data.resCode === '10000') {
          this.total = res.data.resData.pageInfo ? res.data.resData.pageInfo.total : 0;
          const tempArr = res.data.resData.pageList ? res.data.resData.pageList : [];
          this.boxinfo = this.boxinfo.concat(tempArr);
          this.finished = this.boxinfo.length >= this.total ? true : false;
        }else{
          this.$toast(res.data.resDesc);
        }
        this.loading = false;
      });
    },
    shere() {
      var imgUrl = 'http://wechat.tianan.net/img/list1.png';
      var lineLink = location.href.split('#')[0]; 
      var descContent = '主办单位：福田区妇女联合会、泰然天安科技园联合党委';
      var shareTitle = '三八节”关爱抗疫医护巾帼公益活动！';
      var appid = '';
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
          url: location.href.split('#')[0]
        }, {
          headers: { token: this.token }
        }).then((response) => {
          const res = response.data;
          if (res.resCode === '10000') {
            this.scanConfig.appId = res.resData.appId;
            this.scanConfig.timestamp = res.resData.timestamp;
            this.scanConfig.nonceStr = res.resData.nonceStr;
            this.scanConfig.signature = res.resData.signature;
            wx.config({
                debug: false,
                appId: this.scanConfig.appId,
                timestamp: this.scanConfig.timestamp,
                nonceStr: this.scanConfig.nonceStr,
                signature: this.scanConfig.signature,
                jsApiList: [
                    'checkJsApi',
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage'
                ]
            });
            wx.ready(function() {
                          
                          wx.onMenuShareTimeline({
                              title: shareTitle, // 分享标题
                              link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                              imgUrl: imgUrl, // 分享图标
                              success: function () {
                                  // 用户确认分享后执行的回调函数
                              },
                              cancel: function () {
                                  // 用户取消分享后执行的回调函数
                              }
                          });
                          wx.onMenuShareAppMessage({
                              title: shareTitle, // 分享标题
                              desc: descContent, // 分享描述
                              link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                              imgUrl: imgUrl, // 分享图标
                              type: '', // 分享类型,music、video或link，不填默认为link
                              dataUrl:'' , // 如果type是music或video，则要提供数据链接，默认为空
                              success: function () {
                                  // 用户确认分享后执行的回调函数
                                  
                              },
                              cancel: function () {
                                  // 用户取消分享后执行的回调函数
                              }
                          });
                  });
          } else {
            Toast.fail({ duration: 1500, message: res.resDesc });
          }
      });
    },
    toModule(path) {
      this.$router.push({ path: path });
    },
    back(){
        this.$router.go(-1);//返回上一层
    },
    toScan() {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else {

        this.getJsSdkConfigParams();
      }
    },
    // 获取微信扫码配置
    getJsSdkConfigParams() {
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
        url: location.href.split('#')[0]
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.scanConfig.appId = res.resData.appId;
          this.scanConfig.timestamp = res.resData.timestamp;
          this.scanConfig.nonceStr = res.resData.nonceStr;
          this.scanConfig.signature = res.resData.signature;
          this.config();
        } else {
          Toast.fail({ duration: 1500, message: res.resDesc });
        }
      });
    },
    // 扫码
    config() {
      wx.config({
        debug: false,
        appId: this.scanConfig.appId,
        timestamp: this.scanConfig.timestamp,
        nonceStr: this.scanConfig.nonceStr,
        signature: this.scanConfig.signature,
        jsApiList: ['checkJsApi', 'scanQRCode']
      });


      // 配置出错
      wx.error((res) => {
        Toast.fail({ duration: 1500, message: `${res.errMsg}` });
      });

      // 配置成功之后的回调
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList : ['scanQRCode'],
          success : (res) => {
          }
        });
        wx.scanQRCode({
          /**
           * 此处为0才能使用PC官网的扫一扫登陆功能
           * 因为微信的登陆二维码做了特殊处理，必须直接由微信扫码跳转过去才行
           * 例如把微信登陆二维码识别为文本url后再点击也是不行的，必须由微信直接扫码跳转（微信会识别来源方式）
           * 所以如果要兼容官网微信登陆功能，这里就无法由我们自行处理二维码内容
           */
          needResult : 0,
          scanType : ["qrCode"],
        });
      });
    },
    loadMore() {
      if (this.boxinfo.length >= this.total) {
        return;
      }
      this.loading = true;
      this.pageIndex++;
      this.getinfo();
    },
  },
  mounted() {
    this.getinfo();
    this.shere();
  },
  computed: {
    ...mapGetters(['currentParkId','token']),
  },
}
</script>
<style lang="scss" scoped>
.ExclusiveActivities{
  // padding: .32rem;
  .van-list{
    padding-bottom: 1.2rem;
  }
   .van-notice-bar{
    padding: 0px;
    background: #fff;
    height: auto;
    font-size: .32rem;
    color: #d9262c;
    width: 5.2rem;
    margin-top: .16rem;
  }
  .divicon{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i{
      padding-bottom: .1rem;
    }
  }
  .onehome{
    background: #205eff;
    width: 100%;
    height: 1.2rem;
    display: flex;
    justify-content:space-between;
    align-items: center;
    .return{
      padding-left: .18rem;
    }
    .title{
      text-align: center;
      color: #fff;
      padding-left: .88rem;
    }
    .imgbox{
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: .18rem;
    }
  }
  .titlef{
    background: #fff;
    display: flex;
    justify-content:space-between;
    padding: .32rem .48rem;
    // border-bottom: 1px solid #949fa6;
    // margin-bottom: .1rem;
    h3{
      border-left:4px solid #288ff8;
      padding-left: .2rem;
      font-weight: 600;
      height: 0.49rem;
      line-height: .49rem;
    }
    p{
      color: #949fa6;
    }
  }
  .boxBig{
    width: 100%;
    height: 2.666667rem;
    background-color: #fff;
    border-radius: .106667rem;
    margin-bottom: .266667rem;
    padding: .333333rem .266667rem;
    display: flex;
    align-items: center;
    .img_b{
      vertical-align: middle;
      display: inline-block;
      // width: 3.546667rem;
      height: 82%;
      border-radius: .106667rem;
    }
    .content{
      vertical-align: middle;
      flex: 1;
      padding-left: .28rem;
      .boxTitle{
        font-size: .4rem;
        font-weight: bold;
        width: 5.2rem;
      }
      .boxPreferential{
        font-size: .32rem;
        color: rgb(217, 38, 44);
        width: 5.2rem;
        margin-top: .16rem;
      }
      .boxCompany{
        font-size: .266667rem;
        color: rgb(102, 102, 102);
        width: 5.2rem;
        margin-top: .106667rem;
      }
      .boxLimitTime{
        font-size: .266667rem;
        color: rgb(102, 102, 102);
        width: 5.2rem;
        margin-top: .106667rem;
      }
    }
  }
}
.in_b{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/parkCompleteSet/components/ExclusiveActivities.vue